import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import RecentlyUsedModulesSection from 'LayoutBuilderUI/components/panels/sidebar/RecentlyUsedModulesSection';
import DefaultModulesSection from 'LayoutBuilderUI/components/panels/sidebar/DefaultModulesSection';
import CustomModulesSection from 'LayoutBuilderUI/components/panels/sidebar/CustomModulesSection';
import { getCanUseCustomModules } from 'EmailEditorUI/redux/selectors/AuthSelectors';
// @ts-expect-error no declarations found for module
import { reportAddModuleSidebarLoaded } from 'LayoutBuilderUI/actions/ApiActions';
import { getModulesSearchTerm } from 'EmailEditorUI/redux/selectors/selected';
import { EmptySearchResult } from 'LayoutBuilderUI/components/panels/sidebar/EmptySearchResults';
import { getCountOfDefaultFilteredModules, getCountOfCustomFilteredModules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModulesSections = () => {
  const canUseCustomModules = useSelector(getCanUseCustomModules);
  const searchTerm = useSelector(getModulesSearchTerm);
  const countOfDefaultFilteredModules = useSelector(getCountOfDefaultFilteredModules);
  const countOfCustomFilteredModules = useSelector(getCountOfCustomFilteredModules);
  useEffect(() => {
    reportAddModuleSidebarLoaded();
  }, []);
  if (countOfDefaultFilteredModules + countOfCustomFilteredModules === 0) {
    return /*#__PURE__*/_jsx(EmptySearchResult, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!searchTerm && /*#__PURE__*/_jsx(RecentlyUsedModulesSection, {}), /*#__PURE__*/_jsx(DefaultModulesSection, {}), canUseCustomModules && /*#__PURE__*/_jsx(CustomModulesSection, {})]
  });
};
export default ModulesSections;